import { Center, Pagination } from "@mantine/core"
import type { useAppPagination } from "@/hooks"

export function AppPagination({ total, limit, offset, setOffset }: ReturnType<typeof useAppPagination>) {
  if (!total) return null

  const pageTotal = Math.ceil(total / limit)
  const curPage = Math.ceil(offset / limit) + 1

  if (pageTotal <= 1) return null

  return (
    <Center>
      <Pagination color="gray" total={pageTotal} value={curPage} onChange={(page) => setOffset((page - 1) * limit)} />
    </Center>
  )
}
